import { render } from "./SpaItinerary.vue?vue&type=template&id=79a903b9&scoped=true"
import script from "./SpaItinerary.vue?vue&type=script&lang=js"
export * from "./SpaItinerary.vue?vue&type=script&lang=js"

import "./SpaItinerary.vue?vue&type=style&index=0&id=79a903b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a903b9"]])

export default __exports__